<template>
    <Header :class="{ 'color-primaryColor': !isHomePage }" />
    <div :class="{ 'bg-#fff': !isHomePage }" :style="layoutBackgroundStyle"
        class="layout-container min-h-[calc(100vh)]">
        <router-view />
        <FloatBox />
    </div>
    <Footer />
</template>
<script setup lang="ts">
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import FloatBox from "./components/FloatBox.vue"
import { useLayoutBackground } from '@/hooks/useLayoutBackground';

import { setRem } from '@/responsive';
const { currentRoute } = useRouter();
const isHomePage = computed(() => currentRoute.value.path === '/Home');
const { layoutBackgroundStyle } = useLayoutBackground();
</script>
